import { qbHttp } from "./http";

export const listProducts = (params = {}) =>
  qbHttp.request("api/qb/products", { query: params });

export const getProduct = (id) => qbHttp.request(`api/qb/products/${id}`);

export const createProduct = (body) =>
  qbHttp.request("api/qb/products", { method: "POST", body });

export const updateProduct = (id, body) =>
  qbHttp.request(`api/qb/products/${id}`, { method: "PUT", body });

export const deleteProduct = (id) =>
  qbHttp.request(`api/qb/products/${id}`, { method: "DELETE" });

export const addPricing = (productId, body) =>
  qbHttp.request(`api/qb/products/${productId}/pricing`, { method: "POST", body });

export const updatePricing = (productId, pricingId, body) =>
  qbHttp.request(`api/qb/products/${productId}/pricing/${pricingId}`, { method: "PUT", body });

export const deletePricing = (productId, pricingId) =>
  qbHttp.request(`api/qb/products/${productId}/pricing/${pricingId}`, { method: "DELETE" });
